const WINDOW_SLOTS = 6;

function nextScheduleBlocks(allBlocks, selectedBlocks, tapped, options = {}) {
  const blocks = Array.isArray(allBlocks) ? allBlocks : [];
  const selected = Array.isArray(selectedBlocks) ? selectedBlocks : [];
  const start = tapped && tapped.start;
  if (!start) return { error: 'Choose a time.' };

  const selectedIndex = selected.findIndex((block) => block.start === start);
  if (selectedIndex >= 0) {
    return { blocks: selected.slice(0, selectedIndex + 1) };
  }

  const startIndex = blocks.findIndex((block) => block.start === start);
  if (startIndex === -1) return { error: 'Choose a time.' };

  const windowBlocks = blocks.slice(startIndex, startIndex + WINDOW_SLOTS);
  const slotIsClosed = (block) => {
    if (block.conflictTitle && options.allowConflicts) return false;
    return !block.available || Boolean(block.conflictTitle);
  };
  const blockedSlot = windowBlocks.find(slotIsClosed);
  const windowOpen =
    windowBlocks.length >= WINDOW_SLOTS && !blockedSlot;
  if (windowOpen) return { blocks: windowBlocks };

  const tappedOk = options.allowConflicts
    ? Boolean(tapped.available) || Boolean(tapped.conflictTitle)
    : Boolean(tapped.available) && !tapped.conflictTitle;
  if (options.allowSingle && tappedOk) {
    return { blocks: [blocks[startIndex]] };
  }

  const base =
    windowBlocks.length < WINDOW_SLOTS
      ? 'Please choose a start time with 3 full hours available.'
      : 'The selected 3-hour window includes an unavailable or conflicting slot.';
  const hint = tappedOk ? ' Tap this time again to book 30 minutes.' : '';
  return { error: base + hint };
}

module.exports = {
  nextScheduleBlocks,
};
